import React, { useEffect, useState } from 'react'
import useWebSocket from '../WebSocketManager'
import { REMAINING_COUNT_SOCKET_URL } from '../../envVariables';
import './ManualNumber.css'
import useCreateSound from '../../hooks/useCreateSound';


const LastDrawnNumber = ({ number }) => {
    return (
        <div className="latestDrawnBall mainNumber animation-fade">
            {number}
        </div>
    )
}



const ManualNumber = ({ setCalledNumbers, storageKey, setgameEnds, handleCloseModal, setIsSocketNum }) => {
    const [isBallDrawn, setIsBallDrawn] = useState(null)
    const { playSound } = useCreateSound();
    const handleManualNumber = (data) => {
        playSound(data?.drawNumber);
        setIsSocketNum(true);

        const drawNumbers = data?.allDrawNumbers?.map(Number)
        
        setCalledNumbers(drawNumbers);
        setIsBallDrawn({
            lastDrawnNumber: data?.drawNumber
        })

        window.localStorage.setItem(
            storageKey,
            JSON.stringify(data.allDrawNumbers)
        );
        if (data.gameEnds) {
            setgameEnds(true);
        } else if (data.message && !data.gameEnds) {
            handleCloseModal({
                status: true,
                test: "The game has been cancelled, and refunds have been processed",
            });
        }


    };
    useWebSocket(
        `${REMAINING_COUNT_SOCKET_URL}`,
        "manual-number-draw",
        handleManualNumber,
        true
    );
    // useEffect(() => {
    //     if (isBallDrawn) {
    //         const timeout = setTimeout(() => {
    //             setIsBallDrawn(null);
    //         }, 3000);
    //         return () => clearTimeout(timeout);
    //     }
    // }, [isBallDrawn]);


    return (
        <div
            className="relative w-[100px] xl:w-[150px]"
        >
            {isBallDrawn?.lastDrawnNumber && (
                <LastDrawnNumber key={isBallDrawn?.lastDrawnNumber} number={isBallDrawn?.lastDrawnNumber} />
            )}
        </div>
    )
}

export default ManualNumber